import React from 'react';
import PropTypes from 'prop-types';
import PieChart from './PieChart';
import QuickStats from './QuickStats';
import DataTable from './DataTable';
import LoadingOverlay from '../LoadingOverlay';
import ResultsWrapper from './ResultsWrapper';
import { CLOSERS_TABLE, PROVIDER_TABLE } from './config';

const HOUR_MINUTES = 60;

function ResultsOverview({ analytics }) {
  return (
    <LoadingOverlay active={analytics.fetching}>
      {analytics.data && (
        <div>
          <QuickStats
            stats={[
              {
                label: 'Total Deals',
                value: analytics.data.totalCount,
                tooltip:
                  'The total number of deals that has been accepted into by Upstart. These include leads that have come through your third party Vendors.',
              },
              {
                label: 'Vehicles Sold Through Upstart',
                value: analytics.data.soldCount,
                tooltip:
                  'The total number of vehicles marked as sold through Upstart Instore.',
              },
              {
                label: 'Upstart Leads',
                value: analytics.data.totalProdigyCount,
                tooltip:
                  'The aggregated result of leads that have started through Upstart Online and Upstart Instore. These do not include the enhanced leads',
              },
              {
                label: 'Leads Enhanced',
                value: analytics.data.enhancedCount,
                tooltip:
                  'The aggregated of third party leads that have come through Upstart and we enhanced them for you. Talk to your representative if you have not yet enabled this feature.',
              },
              {
                label: 'Est. Time saved with Upstart',
                value: `${Math.ceil(
                  analytics.data.totalMinutes / HOUR_MINUTES,
                )} hr`,
                tooltip:
                  'Hours calculated based on industry average vs time spent on Upstart.',
              },
              {
                label: 'In-store Customers From Online',
                value: analytics.data.onlineToStoreCount,
                tooltip:
                  'The total number of Upstart Online customers that switched to Upstart Instore.',
              },
            ]}
          />
          <div className="row">
            <div className="col-sm-6">
              <PieChart
                data={[
                  {
                    id: 'Online Deals',
                    value: analytics.data.onlineOriginCount,
                  },
                  {
                    id: 'Instore Deals',
                    value: analytics.data.storeOriginCount,
                  },
                ]}
              />
            </div>
            <div className="col-sm-6">
              <PieChart
                data={[
                  {
                    id: 'Online Leads',
                    value: analytics.data.onlineOriginCount,
                  },
                  {
                    id: '3rd Party Leads',
                    value: analytics.data.forwardedOriginCount,
                  },
                ]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="data-table-label">Top Closers</div>
              <DataTable
                data={analytics.data.salespersonStatistics}
                config={CLOSERS_TABLE}
              />
            </div>
            <div className="col-sm-6">
              <div className="data-table-label">Enhanced Leads by Source</div>
              <DataTable
                data={analytics.data.providerStatistics}
                config={PROVIDER_TABLE}
              />
            </div>
          </div>
        </div>
      )}
    </LoadingOverlay>
  );
}

ResultsOverview.propTypes = {
  analytics: PropTypes.object.isRequired,
};

export default ResultsWrapper(ResultsOverview);
